import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/www/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import cookie from 'cookie';

/**
 * @returns {string|null}
 */
function getAccessToken() {
  return document && document.cookie ? cookie.parse(document.cookie).token : null;
}

/**
 * 
 * @param {string} url 
 * @returns {[{Function}, Object]}
 */
export var useFileDownload = function useFileDownload(url) {
  var _useState = useState(false),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var fetchFile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, _response$headers$get, _response$headers$get2, filename, fileBlob, a;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return fetch(url, {
                headers: {
                  Authorization: "Bearer ".concat(getAccessToken())
                }
              });
            case 4:
              response = _context.sent;
              _response$headers$get = response.headers.get('Content-Disposition').split('='), _response$headers$get2 = _slicedToArray(_response$headers$get, 2), filename = _response$headers$get2[1];
              _context.next = 8;
              return response.blob();
            case 8:
              fileBlob = _context.sent;
              a = document.createElement('a');
              a.href = window.URL.createObjectURL(fileBlob);
              ;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              a.remove();
              _context.next = 21;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](1);
              setError(_context.t0);
            case 21:
              setLoading(false);
            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 18]]);
    }));
    return function fetchFile() {
      return _ref.apply(this, arguments);
    };
  }();
  return [fetchFile, {
    loading: loading,
    error: error
  }];
};